import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Layout, Avatar, Typography, Icon, Alert, Tooltip, Dropdown, Menu, Divider, Card, Descriptions, Button, InputNumber } from 'antd';
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome';
import { updateCurrentUserAction } from '../../redux/actions';
import { getIndianRupeeNotation, get_user_avatar, goToEasebuzz, handleApiExceptions, alertify } from '../../app_methods';
import Text from 'antd/lib/typography/Text';
import { faUser, faCog, faMeteor, faPowerOff, faFileInvoice, faIdCard, faKey, faBars, faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { PermissionHoc } from '../../components/HOC';
import { ChangePasswordModal } from '../../components/Settings/change-password-modal';
// import KYCModal from '../../components/Merchants/List/kyc_modal';
import { MerchantModal } from '../../components/Common';
import { Merchant } from '../../models';
import { MerchantService } from '../../services';
import { EaseModal } from '../../libs/EaseModal';
import { DangerousLink, Text3, Text4 } from '../../styles';
import { BANK_CODE } from '../../constants';
import { isMobile, MobileView } from 'react-device-detect';
import { TutorialModal } from "./tutorialModal";
import { Tabs } from 'antd';
import { Input } from 'antd';
import { TransactionHistoryDrawer } from '../../components/PgTransactionHistory/List/TransactionHistoryInfo';
import CreditCardModal from '../../components/Common/CreditCardModal';
// import EasebuzzCheckout ;

const SettingsPermissableMenu = PermissionHoc(Menu.Item, "SETTINGS_READ", { is_component: true, fallbackComponent: null })
const InvoicesPermissableMenu = PermissionHoc(Menu.Item, "INVOICES_READ", { is_component: true, fallbackComponent: null })
const UsersPermissableMenu = PermissionHoc(Menu.Item, "USERS_READ", { is_component: true, fallbackComponent: null })
const MerchantsPermissableMenu = PermissionHoc(Menu.Item, "MERCHANTS_READ", { is_component: true, fallbackComponent: null })

const NavBar = (props) => {
    const [isUploadingKYC, setIsUploadingKYC] = useState(false);
    const [showKYCModal, setShowKYCModal] = useState(false);
    const [isSavingProfile, setIsSavingProfile] = useState(false);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [fetching, setFetching] = useState(false);
    const [showBalanceModal, setShowBalanceModal] = useState(false);
    const [showTutorialModal, setShowTutorialModal] = useState(false);
    const [isFetchingKycURL, setIsFetchingKycURL] = useState(false);

    const fetchMerchantInfo = () => {
        setFetching(true);
        MerchantService.fetch().then((response) => {
            console.log('Navbar call', response.data.merchant)
            if (response.success) props.updateCurrentUser(response.data.merchant);
            setFetching(false);
        }).catch((error) => {
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
            setFetching(false);
        })
    };

    const openKYCPage = async () => {
        setIsFetchingKycURL(true);
        const merchant = new Merchant(props.current_user);
        const response = await merchant.get_merchant_kyc_url();
        if (!response.success) {
            setIsFetchingKycURL(false);
            handleApiExceptions(response);
            return;
        }
        window.open(response.data.signed_url, "_blank")
        setIsFetchingKycURL(false);
    };

    const uploadMerchantKYC = async (values) => {
        setIsUploadingKYC(true);
        const merchant = new Merchant(props.current_user);
        const response = await merchant.upload_kyc({ ...values, key: props.current_user.key });
        if (!response.success) {
            setIsUploadingKYC(false);
            handleApiExceptions(response);
            return;
        }
        toggleKYCModal();
        alertify("Success", "KYC uploaded successfully.", "success");
        setIsUploadingKYC(false);
        fetchMerchantInfo();
    };

    const saveMerchant = async (values) => {
        setIsSavingProfile(true);
        const merchant = new Merchant(values);
        const response = await merchant.save();
        if (!response.success) {
            setIsSavingProfile(false);
            handleApiExceptions(response);
            return;
        }
        toggleProfileModal();
        alertify("Success", `Profile updated successfully.`, "success");
        setIsSavingProfile(false);
        fetchMerchantInfo();
    };

    const toggleBalanceModal = () => {
        setShowBalanceModal(!showBalanceModal);
    };

    const toggleKYCModal = () => {
        setShowKYCModal(!showKYCModal);
    };

    const toggleProfileModal = () => {
        setShowProfileModal(!showProfileModal);
    };

    const toggleChangePasswordModal = () => {
        setShowChangePasswordModal(!showChangePasswordModal);
    };

    const toggleTutorialModal = () => {
        setShowTutorialModal(!showTutorialModal);
    };


    const EnableFundingViaNetBanking = () => {
        return (
            <>
                <div className="font-weight-bold mb-3" style={{ fontSize: "18px" }}>{virtual_account.account_type_label}</div>
                <div
                    className={`mb-2`}
                >
                    <div className="row">
                        <div className="col-5">
                            <Text3 type="secondary" strong>A/C Holder:</Text3>
                        </div>
                        <div className="col-7">
                            <Text3>{props.current_user.name}</Text3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            <Text3 type="secondary" strong>A/C Number:</Text3>
                        </div>
                        <div className="col-7">
                            <Text3>{virtual_account.virtual_account_number}</Text3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            <Text3 type="secondary" strong>IFSC:</Text3>
                        </div>
                        <div className="col-7">
                            <Text3>{virtual_account.virtual_ifsc_number}</Text3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            <Text3 type="secondary" strong>Usable Balance:</Text3>
                        </div>
                        <div className="col-7">
                            <Text3>₹ {`${balanceObj.integer}${balanceObj.decimal ? `.${balanceObj.decimal}` : ""}`} /-</Text3>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-12">
                            <Text3 strong>PLEASE NOTE:</Text3>
                            <ul className="mt-1" style={{ paddingLeft: "5%" }}>
                                <li><Text4>You can use IMPS, NEFT or RTGS to transfer funds in above account.</Text4></li>
                                <li><Text4>Balance would get updated within 30 minutes after we receive funds.</Text4></li>
                                <li><Text4>NEFT and RTGS may take longer as per bank timings.</Text4></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const virtual_account = props.current_user.virtual_account || {};
    const balanceObj = getIndianRupeeNotation(virtual_account.balance || 0, 3);

    return (
        <div className="navbar-wrapper" style={{ paddingLeft: isMobile & !props.sidebarCollapsed ? 225 : 0 }}>

            {
                props.activeSidebar != 'insta-collect' && props.current_user.user && props.current_user.user.permissions.includes('VIRTUAL_ACCOUNTS_READ') ?
                    <BalanceArea {...props} fetchMerchantInfo={fetchMerchantInfo} toggleBalanceModal={toggleBalanceModal} isFetching={fetching} />
                    : <div className="invisible"></div>
            }

            <div>
                <div className="d-flex">
                    <Button className="align-self-center mr-1" type="link" onClick={toggleTutorialModal}><Icon type="video-camera" /> Watch the tutorial video</Button>

                    <Dropdown trigger={['click']} overlayStyle={{ width: 190 }} className="navbar-dropdown ml-auto" placement="bottomRight" overlay={false ? <></> : (
                        <Menu>
                            <SettingsPermissableMenu onClick={props.redirect.bind(this, '/settings')}>
                                <FAI icon={faCog} color="grey" /><span className="ml-2">Settings</span>
                            </SettingsPermissableMenu>
                            <InvoicesPermissableMenu onClick={props.redirect.bind(this, '/invoices')}>
                                <FAI icon={faFileInvoice} color="grey" /><span className="ml-2">Billing</span>
                            </InvoicesPermissableMenu>
                            {
                                props.current_user.eum ? (
                                    <UsersPermissableMenu onClick={props.redirect.bind(this, '/users')}>
                                        <FAI icon={faUser} color="grey" /><span className="ml-2">Manage Team</span>
                                    </UsersPermissableMenu>
                                ) : null
                            }
                            {
                                !props.current_user.is_easebuzz_merchant && props.current_user.is_submerchant ? (
                                    <Menu.Divider />
                                ) : null
                            }
                            {
                                !props.current_user.is_easebuzz_merchant && props.current_user.is_submerchant ? (
                                    <MerchantsPermissableMenu onClick={toggleProfileModal}>
                                        <FAI icon={faIdCard} color="grey" /><span className="ml-2">Manage Profile</span>
                                    </MerchantsPermissableMenu>
                                ) : null
                            }
                            {
                                !props.current_user.is_easebuzz_merchant && props.current_user.is_submerchant && props.current_user.profile.token ? (
                                    <MerchantsPermissableMenu onClick={() => openKYCPage()}>
                                        <FAI icon={faIdCard} color="grey" /><span className="ml-2">Manage KYC</span>
                                    </MerchantsPermissableMenu>
                                ) : null
                            }
                            <Menu.Divider />
                            {
                                props.current_user.user && props.current_user.user.id ? (
                                    <Menu.Item onClick={toggleChangePasswordModal}>
                                        <FAI icon={faKey} color="grey" /><span className="ml-2">Change Password</span>
                                    </Menu.Item>
                                ) : null
                            }
                            {
                                props.current_user.is_easebuzz_merchant && props.current_user.user ?
                                    props.current_user.user.is_admin ?
                                        <Menu.Item onClick={() => goToEasebuzz("merchant/dashboard")}>
                                            <FAI icon={faMeteor} color="grey" /><span className="ml-2">Go To Easebuzz</span>
                                        </Menu.Item> : null : null
                            }
                            <Menu.Item onClick={props.logout}>
                                <FAI icon={faPowerOff} color="grey" /><span className="ml-2">Logout</span>
                            </Menu.Item>
                        </Menu>
                    )}>
                        <div className="avatar-wrapper">
                            <span className={`c-pointer user-avatar-name ant-dropdown-link pr-1 pl-1 align-items-center d-flex w-100`} href="#" style={{ display: 'block' }}>
                                <Avatar src={get_user_avatar(props.current_user)} icon="user" size="large" shape="square" className="mr-2" style={{ flexShrink: 0 }} />
                                <div className="d-flex flex-column w-100">
                                    <div className="d-flex align-items-center justify-content-between w-100">
                                        <Text className="ellipsis-2" strong style={{ marginRight: 10, maxWidth: 200, lineHeight: "20px" }}>{props.current_user.user && props.current_user.user.name || props.current_user && props.current_user.name}</Text>
                                        <Icon type="caret-down" style={{ fontSize: 18, alignSelf: 'flex-start' }}></Icon>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </Dropdown>
                </div>
                {virtual_account.funding_via == 2 && props.current_user.enable_funding_via_credit_card ?
                    <CreditCardModal
                        visible={showBalanceModal}
                        onCancel={toggleBalanceModal}
                        virtualAccount={virtual_account}>
                    </CreditCardModal> :
                    <EaseModal
                        width={450}
                        title={false}
                        visible={showBalanceModal}
                        onCancel={toggleBalanceModal}
                        centered
                        hideFooter
                        destroyOnClose
                    >
                        <EnableFundingViaNetBanking />
                    </EaseModal>}
            </div>



            {/* <KYCModal
                title="Upload KYC"
                visible={showKYCModal}
                toggleKYCModal={toggleKYCModal}
                merchant={new Merchant(props.current_user)}
                onSubmit={uploadMerchantKYC}
                loading={isUploadingKYC}
            /> */}
            <MerchantModal
                title="Update Profile"
                visible={showProfileModal}
                toggleMerchantModal={toggleProfileModal}
                merchant={new Merchant({ ...props.current_user, is_edit: true })}
                saveMerchant={saveMerchant}
                loading={isSavingProfile}
            />
            <ChangePasswordModal
                visible={showChangePasswordModal}
                toggleChangePasswordModal={toggleChangePasswordModal}
                merchant={props.current_user}
                user={props.current_user.user}
            />
            <TutorialModal
                visible={showTutorialModal}
                url={"https://www.youtube.com/embed/lJSmwFxkQqo"}
                toggleTutorialModal={toggleTutorialModal}
            />

        </div>
    )
}

const BalanceArea = (props) => {
    
    const virtual_account = props.current_user.virtual_account || {};
    const balanceObj = getIndianRupeeNotation(virtual_account.balance || 0, 3);
    let userBalance=null; 
    if (props?.current_user?.user?.enable_spending_limit){
        userBalance=getIndianRupeeNotation(props?.current_user?.user.balance_amount || 0, 3);
    }
    return (
        <div className="d-flex">
            <div className="balance-wrapper">
                <div className="amount-label c-pointer">
                    <div className="label"> Usable Balance: </div>
                    <div className="amount"> ₹ {`${balanceObj.integer}${balanceObj.decimal ? `.${balanceObj.decimal}` : ""}`} /- </div>
                </div>
                <div className="refresh-icon">
                    <Tooltip title="Get Updated Balance">
                        <Icon
                            // className="reload-icon"
                            type="sync"
                            spin={props.isFetching}
                            onClick={() => { props.fetchMerchantInfo(); }}
                        />
                    </Tooltip>
                </div>
            </div>
            {userBalance ? 
            <div  className="balance-wrapper ml-1">
                <div className="amount-label c-pointer">
                    <div className="label"> Alloted Balance: </div>
                    <div className="amount"> ₹ {`${userBalance.integer}${userBalance.decimal ? `.${userBalance.decimal}` : ""}`} /- </div>
                </div>
                </div>
                :null}
            {!virtual_account.is_alloted_connected_banking &&
                <div className="add-balance-wrapper ml-1">
                    <Tooltip title="Add Funds">
                        <Icon
                            style={{ fontSize: 22 }}
                            type="plus"
                            onClick={() => { props.toggleBalanceModal(); }}
                        />
                    </Tooltip>
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);